import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-revisedpropertyregister',
  templateUrl: './revisedpropertyregister.component.html',
  styleUrls: ['./revisedpropertyregister.component.css']
})
export class RevisedpropertyregisterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/revisedpropertyregister/revisedpropertyregister.component.ts